import { useState } from 'react';
import { Award } from 'lucide-react';
import type { CursoAcademy } from '../academyApi';
import { ModalCertificado } from './ModalCertificado';

type Variante = 'resultado' | 'panel' | 'barra';

interface Props {
  curso: CursoAcademy;
  /** `resultado`: el CTA PRIMARIO de la tarjeta del examen recién aprobado — azul,
   *  como cualquier acción principal de la app. Era blanco con anillo verde, de
   *  secundario, cuando "Volver al curso" ocupaba ese lugar
   *  (ADR-2026-08-25-aprobado-el-cta-es-el-certificado).
   *  `panel`: botón azul a lo ancho, en la columna del curso.
   *  `barra`: el mismo azul a lo ancho pero sin margen propio ni alto reducido —
   *  vive dentro de la barra fija de mobile, que ya pone su padding. */
  variante: Variante;
}

/**
 * "Ver certificado" — abre la lámina del curso aprobado
 * (ADR-2026-08-25-el-certificado-se-ofrece-al-aprobar-y-en-el-panel).
 *
 * Abre y no descarga: el certificado primero se mira y desde ahí se baja. El detalle
 * de por qué está en `ModalCertificado`.
 *
 * El componente sólo tiene el botón; los datos y el PDF los carga el modal, y recién
 * cuando se abre. Así el panel del curso no pide nada a la base ni baja tipografías
 * por un certificado que a lo mejor nadie mira.
 */
export function BotonCertificado({ curso, variante }: Props) {
  const [abierto, setAbierto] = useState(false);

  const clases =
    variante === 'resultado'
      ? 'inline-flex items-center gap-1.5 rounded-xl bg-brand-primary px-4 py-2.5 text-[13.5px] font-semibold text-white transition-colors hover:bg-brand-primary-hover'
      : variante === 'barra'
        ? 'flex w-full items-center justify-center gap-2 rounded-xl bg-brand-primary py-3.5 text-[15px] font-semibold text-white transition-colors active:bg-brand-primary-hover'
        : 'mt-2.5 flex w-full items-center justify-center gap-1.5 rounded-xl bg-brand-primary py-2.5 text-[13.5px] font-semibold text-white transition-colors hover:bg-brand-primary-hover';

  return (
    <>
      <button type="button" onClick={() => setAbierto(true)} className={clases}>
        <Award
          className={variante === 'panel' ? 'h-3.5 w-3.5' : 'h-4 w-4'}
          strokeWidth={2.2}
        />
        Ver certificado
      </button>
      {abierto && <ModalCertificado curso={curso} onCerrar={() => setAbierto(false)} />}
    </>
  );
}
